import { render, staticRenderFns } from "./VisitCallPopup.vue?vue&type=template&id=6e366e3e&"
import script from "./VisitCallPopup.vue?vue&type=script&lang=js&"
export * from "./VisitCallPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-user-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e366e3e')) {
      api.createRecord('6e366e3e', component.options)
    } else {
      api.reload('6e366e3e', component.options)
    }
    module.hot.accept("./VisitCallPopup.vue?vue&type=template&id=6e366e3e&", function () {
      api.rerender('6e366e3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/druginfo/VisitCallPopup.vue"
export default component.exports